import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";
import { useRunsWithOpener } from "../llmChoice/runsWithOpener";
import { useThreadContext } from "../page/threadPageContext";
import { allows } from "../page/viewerActions";

/**
 * No LLM chosen for the Thread yet (F67): its host gets one action that opens the header's own
 * "Runs with" picker, the one place the Thread's default is chosen (W-07, S12 decided (a) by the
 * lead): the same component and state, scrolled into view and focused, never a second row.
 * Anyone else reads whose choice it is.
 */
export default function ChooseAgent() {
  const { t } = useTranslation();
  const { overview, nameOf } = useThreadContext();
  const opener = useRunsWithOpener();
  if (!allows(overview.viewer, "change_settings")) {
    return <span>{t("threads.composer.hostChoosesAgent", { name: nameOf(overview.host) })}</span>;
  }
  return (
    <AppButton variant="primary" size="xs" onClick={() => { opener?.open(); }}>
      {t(overview.settings.route === null ? "threads.llm.chooseUnderRunsWith" : "threads.header.change")}
    </AppButton>
  );
}
